import React, { Component } from 'react';
import {
  selectFieldSum,
  selectFieldPaymentSystem,
  selectCommissionDesc,
  selectResultObject
} from 'mt-react-common/modules/payment/reducers/paymentForm/selectors';
import {
  sendForm,
  setFieldSum,
  setFieldPaymentSystem
} from 'mt-react-common/modules/payment/reducers/paymentForm/actions';
import {
  hasFieldError,
  selectFirstErrorByFiled
} from 'mt-react-common/common/reducers/_formErrors/reducer';
import { selectRequestStatusData } from 'mt-react-common/common/reducers/_requestStatus/reducer';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { t } from 'utils/translates';
import { getValueFromRefDataModules } from 'mt-react-common/modules/main/reducers/static/states/referenceLists/reducer';
import OpacityPreLoader from '../../Common/PreLoaders/OpacityPreLoader';
import './index.css';

class PaymentForm extends Component {
  componentDidUpdate(prevProps) {
    // Если появился resultObject с ссылкой то перенаправляем на страницу оплаты
    if (
      prevProps.resultObject !== this.props.resultObject &&
      this.props.resultObject.externalPaymentUrl
    ) {
      window.location.href = this.props.resultObject.externalPaymentUrl;
    }
  }

  handleChangeField = async event => {
    switch (event.target.name) {
      case 'sum':
        this.props.setFieldSum(event.target.value);
        break;
      default:
        break;
    }
  };

  handleSubmit = async event => {
    event.preventDefault();
    this.props.sendForm();
  };

  render() {
    const errorDesc = fieldName => {
      if (this.props.hasFieldError(fieldName)) {
        return (
          <React.Fragment>
            <small className="divider" />
            <small className="help-block">
              {this.props.selectFirstErrorByFiled(fieldName).message}
            </small>
          </React.Fragment>
        );
      }
      return null;
    };
    return (
      <React.Fragment>
        {this.props.requestStatusData.requestInProcess ||
        this.props.resultObject.externalPaymentUrl ? (
          <OpacityPreLoader />
        ) : null}
        <div className="row">
          <div className="col-md-24 col-sm-24 col-xs-24">
            <form onSubmit={this.handleSubmit}>
              <div className="row">
                <div className="p-l-10 col-md-12 col-sm-24 col-xs-24 p-r-10">
                  <div
                    className={`form-group ${
                      this.props.hasFieldError('sum') ? 'has-error' : ''
                    }`}
                  >
                    <label className="control-label" htmlFor="inputPayFromOut">
                      {t('Сумма пополнения')}
                    </label>
                    <div className="input-group">
                      <input
                        onChange={this.handleChangeField}
                        value={this.props.fieldSum.value}
                        className="form-control"
                        id="inputPayFromOut"
                        name="sum"
                        placeholder={t('Сумма пополнения')}
                        type="number"
                      />
                      <span className="input-group-addon">
                        <i aria-hidden="true" className="fa fa-rub" />
                      </span>
                    </div>
                    <small className="help-block">
                      {this.props.commissionDesc}
                    </small>
                    {errorDesc('sum')}
                  </div>
                </div>
                <div className="p-l-10 col-md-12 col-sm-24 col-xs-24 p-r-10">
                  <div
                    className={`form-group ${
                      this.props.hasFieldError('paymentSystem')
                        ? 'has-error'
                        : ''
                    }`}
                  >
                    <label className="control-label" htmlFor="inputPayFromOut">
                      {t('Платежная система')}
                    </label>
                    <div className="control-group">
                      {Object.keys(this.props.activePaymentsTypes).map(key => {
                        const label = this.props.activePaymentsTypes[key];
                        return (
                          <div className="radio abc-radio">
                            <input
                              checked={
                                this.props.fieldPaymentSystem.value === key
                              }
                              onChange={() =>
                                this.props.setFieldPaymentSystem(key)
                              }
                              type="radio"
                              name="paymentSystem"
                              id={`paymentSystem${key}`}
                            />
                            <label htmlFor={`paymentSystem${key}`}>
                              {label}
                            </label>
                          </div>
                        );
                      })}
                    </div>
                    {errorDesc('paymentSystem')}
                  </div>
                </div>
              </div>
              <div className="form-group">
                <button className="btn btn-primary btn-block" type="submit">
                  {t('Пополнить')}
                </button>
              </div>
            </form>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

PaymentForm.propTypes = {
  setFieldSum: PropTypes.func.isRequired,
  setFieldPaymentSystem: PropTypes.func.isRequired,
  sendForm: PropTypes.func.isRequired,

  requestStatusData: PropTypes.shape({
    requestInProcess: PropTypes.bool,
    codeResponse: PropTypes.number
  }).isRequired,

  hasFieldError: PropTypes.func.isRequired,
  selectFirstErrorByFiled: PropTypes.func.isRequired,

  fieldSum: PropTypes.shape({
    value: PropTypes.any.isRequired
  }).isRequired,
  fieldPaymentSystem: PropTypes.shape({
    value: PropTypes.any.isRequired
  }).isRequired,

  commissionDesc: PropTypes.string.isRequired,

  // eslint-disable-next-line react/require-default-props
  resultObject: PropTypes.shape({
    externalPaymentUrl: PropTypes.string
  }),
  activePaymentsTypes: PropTypes.arrayOf(PropTypes.number).isRequired
};

const mapStateToProps = (state, props) => ({
  requestStatusData: selectRequestStatusData(props.reducerName, state),
  hasFieldError: fieldName =>
    hasFieldError(state, props.reducerName, fieldName),
  selectFirstErrorByFiled: fieldName =>
    selectFirstErrorByFiled(state, props.reducerName, fieldName),

  fieldSum: selectFieldSum(state, props.reducerName),
  fieldPaymentSystem: selectFieldPaymentSystem(state, props.reducerName),

  commissionDesc: selectCommissionDesc(state, props.reducerName),

  resultObject: selectResultObject(state, props.reducerName),
  activePaymentsTypes: getValueFromRefDataModules(
    state,
    'payments.activePaymentsTypes'
  )
});

const mapDispatchToProps = (dispatch, props) => ({
  setFieldSum: value => dispatch(setFieldSum(props.reducerName, value)),
  setFieldPaymentSystem: value =>
    dispatch(setFieldPaymentSystem(props.reducerName, value)),
  sendForm: () => dispatch(sendForm(props.reducerName))
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(PaymentForm);



// WEBPACK FOOTER //
// ./src/components/Payments/PaymentForm/PaymentForm.js